import { useRouteMatch } from "react-router-dom";

import { linkToClassroomSection } from "../links";

export function useIsInSection() {
  return useRouteMatch(linkToClassroomSection());
}
